import { GuardianExpoSection } from './GuardianExpoSubPageLayout'
import ScheduleDayTabs from './ScheduleDayTabs'
import { CLASS_BG_COLORS, DEFAULT_CLASS_COLOR } from '../utils/lectureClassColors'

/**
 * 講座時程表區塊（tab 依日期切換，自動預選今天）
 * days: [{ year, month, date, weekday, sessions: [{ time, title, subtitle, speaker?: { title, name } }] }]
 */
export default function LectureScheduleSection({ titleBlack, titleRed, days, first = false, last = false }) {
  return (
    <GuardianExpoSection titleBlack={titleBlack} titleRed={titleRed} first={first} last={last}>
      <ScheduleDayTabs
        days={days}
        renderDay={(day) => {
          const groupedSessions = (day.sessions || []).reduce((acc, session) => {
            const lastGroup = acc[acc.length - 1]
            if (lastGroup && lastGroup.classNumber === session.classNumber) {
              lastGroup.sessions.push(session)
            } else {
              acc.push({ classNumber: session.classNumber, sessions: [session] })
            }
            return acc
          }, [])

          return (
            <div className="flex flex-col self-stretch" style={{ gap: 40 }}>
              {groupedSessions.map((group, gIdx) => (
                <div key={gIdx} className="grid grid-cols-1 md:grid-cols-2 self-stretch" style={{ gap: 16 }}>
                  {group.sessions.map((session, sIdx) => (
                    <LectureSessionCard key={sIdx} session={session} />
                  ))}
                </div>
              ))}
            </div>
          )
        }}
      />
    </GuardianExpoSection>
  )
}

function LectureSessionCard({ session }) {
  const headerBackground = CLASS_BG_COLORS[session.classNumber] || DEFAULT_CLASS_COLOR
  return (
    <div
      className="flex flex-col items-start self-stretch bg-white overflow-hidden"
      style={{ borderRadius: 8, boxShadow: '2px 4px 8px rgba(110,98,91,0.08)', outline: '3px solid rgba(110,98,91,0.20)', outlineOffset: '-3px' }}
    >
      <div className="flex items-center justify-start gap-3 self-stretch" style={{ height: 30, padding: '0 10px', background: headerBackground, borderBottom: '1px solid rgba(197,155,90,0.08)' }}>
        <span style={{ color: 'white', fontFamily: 'Noto Sans TC', fontSize: 15, fontWeight: 700, lineHeight: '22.5px',width:24 }}>
          {session.class}
        </span>
        <span style={{ color: 'white', fontFamily: 'Noto Sans TC', fontSize: 15, fontWeight: 700, lineHeight: '22.5px', }}>
          {session.time}
        </span>
      </div>
      <div className="flex flex-col items-start self-stretch" style={{ padding: '8px 16px', gap: 4 }}>
        <p style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 500, lineHeight: '27px' }}>
          {session.title}
        </p>
        {session.subtitle && (
          <p style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 16, fontWeight: 300, lineHeight: '24px' }}>
            {session.subtitle}
          </p>
        )}
        {session.speaker && (
          <div
            className="flex items-center justify-between self-stretch"
            style={{ paddingTop: 4, borderTop: '1px solid rgba(110,98,91,0.08)' }}
          >
            <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 16, fontWeight: 300, lineHeight: '24px' }}>
              {session.speaker.title}
            </span>
            <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 16, fontWeight: 500, lineHeight: '24px' }}>
              {session.speaker.name}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
